export default function setHidden(i: number, activeIndex: number){
    return i === activeIndex ? "" : "d-none";
}
